"use client";

import { useEffect } from "react";
import { trackDesignCohort } from "@/lib/track";

// Tags the visit with the park-page design version (for the Matomo "Design
// Version" segment) and fires a countable event, once per park viewed. Renders
// nothing. The parkKey dep re-fires on client-side navigation between parks so
// each distinct park view is counted even without a full remount.
export function TrackParkPage({ version, parkKey }: { version: string; parkKey: string }) {
  useEffect(() => {
    trackDesignCohort(version);
  }, [version, parkKey]);
  return null;
}
